import React, { createContext, useContext, useEffect, useState, type ReactNode } from "react"
import { useMediaQuery } from "react-responsive"

interface MenuMobileContextProps {
  isNotMobile: boolean
  enableMenu: boolean
  handleChangeStatusMenu: () => void
  handleForceCloseMenu: () => void
}

const MenuMobileContext = createContext<MenuMobileContextProps | undefined>(undefined)

export const MenuMobileProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const isNotMobile = useMediaQuery({ query: "(min-width: 769px)" })

  const [enableMenu, setStatus] = useState(isNotMobile)

  useEffect(() => {
    setStatus(isNotMobile)
  }, [isNotMobile])

  const handleChangeStatusMenu = () => {
    setStatus(!enableMenu)
  }

  const handleForceCloseMenu = () => {
    setStatus(false)
  }

  return (
    <MenuMobileContext.Provider
      value={{
        isNotMobile,
        enableMenu,
        handleChangeStatusMenu,
        handleForceCloseMenu,
      }}
    >
      {children}
    </MenuMobileContext.Provider>
  )
}

export const useMenuMobileContext = (): MenuMobileContextProps => {
  const context = useContext(MenuMobileContext)

  if (!context) {
    throw new Error("useMenuMobile deve ser usado dentro de um MenuMobileProvider")
  }

  return context
}
